/*
 * LDC motion: scroll progress for depth sections, 3D tilt on cards and a small bump on the cart icon.
 * Everything is skipped when the visitor prefers reduced motion.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollSections = [...document.querySelectorAll('[data-ldc-scroll]')];

  // Scroll progress (--p from 0 to 1) while a tall section scrolls past its sticky stage
  if (reduceMotion) {
    scrollSections.forEach((section) => section.style.setProperty('--p', 1));
  } else if (scrollSections.length) {
    let ticking = false;

    const update = () => {
      ticking = false;
      const viewportHeight = window.innerHeight;

      scrollSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const distance = Math.max(rect.height - viewportHeight, 1);
        const progress = Math.min(1, Math.max(0, -rect.top / distance));

        section.style.setProperty('--p', progress.toFixed(4));
        section.toggleAttribute('data-open', progress > .15);

        if (section.hasAttribute('data-ldc-night-at')) {
          section.toggleAttribute('data-night', progress > parseFloat(section.dataset.ldcNightAt));
        }
      });
    };

    const requestUpdate = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  // View progress (--v from 0 when entering at the bottom to 1 when leaving at the top) for parallax depth
  const viewElements = [...document.querySelectorAll('[data-ldc-view]')];

  if (!reduceMotion && viewElements.length) {
    let viewTicking = false;

    const updateView = () => {
      viewTicking = false;
      const viewportHeight = window.innerHeight;

      viewElements.forEach((element) => {
        const rect = element.getBoundingClientRect();

        if (rect.bottom < -200 || rect.top > viewportHeight + 200) {
          return;
        }

        const progress = Math.min(1, Math.max(0, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
        element.style.setProperty('--v', progress.toFixed(4));
      });
    };

    window.addEventListener('scroll', () => {
      if (!viewTicking) {
        viewTicking = true;
        requestAnimationFrame(updateView);
      }
    }, { passive: true });

    window.addEventListener('resize', updateView);
    updateView();
  }

  // 3D tilt with a soft light reflection on product cards (mouse only)
  if (!reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const selector = '.ldc-tilt';

    document.addEventListener('pointermove', (event) => {
      const card = event.target.closest(selector);

      if (!card) {
        return;
      }

      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;

      card.style.setProperty('--ldc-ry', `${((x - .5) * 7).toFixed(2)}deg`);
      card.style.setProperty('--ldc-rx', `${((.5 - y) * 7).toFixed(2)}deg`);
      card.style.setProperty('--ldc-gx', `${(x * 100).toFixed(1)}%`);
      card.style.setProperty('--ldc-gy', `${(y * 100).toFixed(1)}%`);
      card.classList.add('is-ldc-tilting');
    }, { passive: true });

    document.addEventListener('pointerout', (event) => {
      const card = event.target.closest(selector);

      if (card && !card.contains(event.relatedTarget)) {
        card.classList.remove('is-ldc-tilting');
        card.style.removeProperty('--ldc-rx');
        card.style.removeProperty('--ldc-ry');
      }
    });
  }

  // Little bump on the cart icon when something is added
  document.addEventListener('cart:change', () => {
    if (reduceMotion) {
      return;
    }

    document.querySelectorAll('.header__cart-count, [href$="/cart"] .count-bubble, cart-count').forEach((element) => {
      element.classList.remove('is-ldc-bump');
      void element.offsetWidth;
      element.classList.add('is-ldc-bump');
    });
  });
})();

/* Give the Instagram feed its spacing once posts have loaded (avoids a costly :has selector) */
(() => {
  const feed = document.querySelector('[id$="__17707355110f1283b7"]');
  if (!feed) return;
  const mark = () => { if (feed.querySelector('#insta-feed img')) { feed.classList.add('ldc-insta-has'); return true; } };
  if (!mark()) new MutationObserver((m, o) => { if (mark()) o.disconnect(); }).observe(feed, { childList: true, subtree: true });
})();

/* Bestsellers on phones: endless, slow auto-slide (pauses while the visitor touches it) */
(() => {
  if (!window.matchMedia('(max-width: 699px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const track = document.querySelector('[id$="__ldc_populair"] scroll-carousel');
  const list = track && track.querySelector('product-list');
  if (!list || list.children.length < 2) return;

  [...list.children].forEach((item) => {
    const clone = item.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a, button, input').forEach((el) => el.setAttribute('tabindex', '-1'));
    list.appendChild(clone);
  });

  track.style.scrollSnapType = 'none';
  track.style.scrollBehavior = 'auto';
  let pos = track.scrollLeft;
  let paused = false;
  let resumeTimer = null;
  let visible = false;
  const speed = 0.45;

  const pause = () => { paused = true; clearTimeout(resumeTimer); };
  const resume = () => { clearTimeout(resumeTimer); resumeTimer = setTimeout(() => { pos = track.scrollLeft; paused = false; }, 2500); };
  track.addEventListener('touchstart', pause, { passive: true });
  track.addEventListener('touchend', resume, { passive: true });
  track.addEventListener('pointerdown', pause);
  track.addEventListener('pointerup', resume);

  new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(track);

  const tick = () => {
    if (visible && !paused) {
      const half = list.scrollWidth / 2;
      pos += speed;
      if (pos >= half) pos -= half;
      track.scrollLeft = pos;
    } else if (paused) {
      const half = list.scrollWidth / 2;
      if (track.scrollLeft >= half) track.scrollLeft -= half;
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
})();
